import React from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames';
import {Typography} from '@material-ui/core';

const styles = theme => ({
    root      : {
        display                       : 'flex',
        alignItems                    : 'center',
        // backgroud                     : 'black',
        '& .logo-text, & .react-badge': {
            transition: theme.transitions.create('opacity', {
                duration: theme.transitions.duration.shortest,
                easing  : theme.transitions.easing.easeInOut
            })
        }
    },
    logo      : {
        // background: 'black'
    },
    logoIcon  : {
        width     : 24,
        height    : 24,
        transition: theme.transitions.create(['width', 'height'], {
            duration: theme.transitions.duration.shortest,
            easing  : theme.transitions.easing.easeInOut
        })
    },
    reactBadge: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        color          : '#61dafb'
    }
});

function MainNavbarHeader({classes})
{
    return (
        <div className={classes.root}>
            {/* <BadgeAward /> */}
            <div className={classNames(classes.logo, "flex items-center")}>
                <img className={classNames(classes.logoIcon, "logo-icon")} src={"http://"+window.location.host+"/assets/images/logos/logopmp.png"} alt="logo"/>
                {/* <img className={classNames(classes.logoIcon, "logo-icon")} src="http://pmp.dikdasmen.kemdikbud.go.id:1745/assets/images/logos/logopmp.png" alt="logo"/> */}
                <Typography className="text-16 ml-8 font-light logo-text" color="inherit" style={{fontSize: '20px', color: '#ffffff'}}><b>EDS</b>2020 Covid-19</Typography>
            </div>
        </div>
    );
};

export default withStyles(styles, {withTheme: true})(withRouter(MainNavbarHeader));



// WEBPACK FOOTER //
// ./src/main/MainNavbarHeader.js